import React from 'react';
import './EmojiLoader.css';

export default function EmojiLoader() {
  return (
    <div className="emoji-loader">
      <span>🚀</span>
      <span>🚀</span>
      <span>🚀</span>
    </div>
  );
}